/**
 * Thin, web-safe accessors for the desktop (`window.electron`) bridge used by the
 * first-time setup wizard.
 *
 * Everything here is feature-detected: in a normal browser build `window.electron`
 * is undefined, `isDesktop()` returns false, and the wizard is never shown.
 */

import settings from '../config/settings';

export const isDesktop = () =>
  typeof window !== 'undefined' && !!window.electron && window.electron.isDesktop === true;

/** The LoopBack base URL the renderer was built against (passed to main for sync). */
export const apiBaseUrl = settings.ROOT_URL;

export const setupApi = isDesktop() ? window.electron.setup : null;
export const authApi = isDesktop() ? window.electron.auth : null;

/** Token validity (ms) used as an offline-expiry fallback when the JWT has no exp. */
export const tokenValidityMs = (() => {
  const minutes = Number(settings.TOKEN_VALIDITY || settings.DEFAULT_TOKEN_VALIDITY || 0);
  return Number.isFinite(minutes) && minutes > 0 ? minutes * 60 * 1000 : 0;
})();
